import * as z from "zod/v4";

export const validateReclaimPartnerCode = {
  name: "validateReclaimPartnerCode" as const,
  input: z.object({ code: z.string().min(1).max(64) }),
  output: z.object({
    status: z.enum(["available", "unavailable"]),
    partnerName: z.string().optional(),
    referralCode: z.string().optional(),
  }),
};
